import { render, staticRenderFns } from "./MaterialWorker.vue?vue&type=template&id=0df3def8&scoped=true&"
import script from "./MaterialWorker.vue?vue&type=script&lang=js&"
export * from "./MaterialWorker.vue?vue&type=script&lang=js&"
import style0 from "./MaterialWorker.vue?vue&type=style&index=0&id=0df3def8&lang=less&scoped=true&"
import style1 from "./MaterialWorker.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df3def8",
  null
  
)

export default component.exports